// extracted by mini-css-extract-plugin
module.exports = {"item":"Incident_item__4c7b3","item2":"Incident_item2__2K0fC"};